export function initAutoDismissAlerts(duration = 4000) {
  const toastElements = document.querySelectorAll('.toast.auto-dismiss');

  // Require global Bootstrap (set on window in index.js or via CDN). Fail quietly if missing.
  if (!window.bootstrap || !window.bootstrap.Toast) {
    return;
  }

  toastElements.forEach((toastEl) => {
    const toast = new window.bootstrap.Toast(toastEl, {
      delay: duration,
      autohide: true,
    });
    toast.show();
  });
}
